<template>
  <ConformationPopup class="pop-up" v-show="showPopup" @close="close"/>
  <div class="banner-container">
    <div class="empty-container">
      <div class="logo" v-if="$route.path === '/' || $route.path === '/options'">
        <img src="https://mass.cloud.ut.ee/android-chrome-192x192.png" width="60" alt="MASS logo">
      </div>
    </div>

    <div class="nav-icons">
      <div class="home-button" @click="openPopup()">
        <img src='@/assets/home.svg'/>
      </div>

      <div class="language-button dropdown">
        <span style="display: flex; align-content: baseline">
          <img src='@/assets/translate.svg'/>
        </span>
        <div style="margin-top: 6px;">
          {{ $t('language') }}
        </div>
        <div class="dropdown-content">
          <LangSwitch></LangSwitch>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LangSwitch from "@/components/LangSwitch";
import ConformationPopup from "./Popups/ConformationPopup.vue";

export default {
  name: 'Banner',
  data() {
    return {
      showPopup: false,
    }
  },
  components: {
    LangSwitch,
    ConformationPopup
  },
  methods: {
    openPopup() {
      if (this.$router.currentRoute.value.name !== 'home') {
        this.showPopup = true;
        document.getElementById("content").classList.add('active-blur');
      }
    },
    close() {
      this.showPopup = false;
      this.showIntroduction = false;
      document.getElementById("content").classList.remove('active-blur');
    },
  }

}
</script>

<style lang="scss" scoped>

.home-button{
  margin-top: -1.5px;
}
.banner-container {
  display: flex;
  gap: 10px;
  top: 0;
  position: fixed;
  background-color: #f0f0f2;
  width: 100%;
  height: 42px;
  z-index: 3;

}

.nav-icons {
  justify-content: flex-end;
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
  cursor: pointer;
  padding-right: 20%;
  align-items: center;
  height: 18px;

}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 15px 25px;
  z-index: 1;
  margin-top: 100px;
}

.language-button {
  display: flex;
  align-items: center;
  gap: 6px
}

.dropdown:hover .dropdown-content {
  display: block;
}

.pop-up {
  top: 20%;
  left: 35%;
}

.logo {
  margin-left: 180px;
  padding-top: 10px;
}

</style>
